import axios from "axios";
import Image from "../ui/Image";

import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft, ChevronLeft, ChevronRight } from "lucide-react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useLanguage } from "../../store/language-context";
import { useTranslation } from "react-i18next";

const Blogs = () => {
  const { URL } = useLanguage();
  const { t } = useTranslation();
  const { data: blogs = [], isLoading, error, refetch } = useQuery({
    queryKey: ['blogs', URL],
    queryFn: async () => {
      const response = await axios.get(`${URL}/blogs?per_page=400`);
      if (response.data.status === 200) {
        return response?.data?.data?.data;
      } else {
        throw new Error(t('custom.err'));
      }
    },
    retry: 1,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 6, // 6HR
    gcTime: 1000 * 60 * 60 * 6,
  });

  return (
    <main>

      <div className="flex justify-center mb-4">
        <p className="services-header flex justify-center after:w-20">{t('routes.all-blogs')}</p>
      </div>

      <section className="flex items-center justify-between gap-4">
        <button className='relative z-50 flex justify-center items-center size-8 border-2 border-secondary-tw rounded-md text-secondary-tw prev-blog'>
          <ChevronRight size={22} className=" ltr:rotate-180" />
        </button>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          loop={true}
          navigation={{
            nextEl: '.next-blog',
            prevEl: '.prev-blog'
          }}
          spaceBetween={30}
          slidesPerView={4}
          breakpoints={{
            0: { slidesPerView: 1 },
            680: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 4 }
          }}
          autoplay={{ delay: 3000, disableOnInteraction: true }}
          draggable={true}
        >
          {isLoading ? (
            <div>
              <div className="grid grid-cols-3 gap-5 max-2xl:grid-cols-2 max-lg:grid-cols-1">
                {[1, 2, 3].map((i) => (
                  <div key={i} className={`relative flex items-center justify-center flex-col ${i === 2 || i === 1 ? 'lg:flex max-lg:hidden' : ''}`}>
                    <div className="l-load w-96 h-60 rounded-md max-lg:w-full"></div>
                    <div className="absolute z-20 bottom-3 flex flex-col items-center w-full px-2 space-y-1">
                      <div className="l-load-dt w-3/4 h-5 rounded"></div>
                      <div className="l-load-dt w-40 h-8 rounded-md"></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : error ? (
            <div className="text-center py-8">
              <p className="text-red-500">{t('custom.err')}</p>
              <button
                className="mt-2 bg-secondary-tw text-white px-4 py-2 rounded-md"
                onClick={() => refetch && refetch()}
              >
                {t('custom.try-again')}
              </button>
            </div>
          ) : blogs.length === 0 ? (
            <p className="text-center py-8">{t('custom.no-data')}</p>
          ) : (
            blogs.map((item) => (
              <SwiperSlide key={item?.id}>
                <div className='relative flex justify-center flex-col'>
                  <div className="relative z-0">
                    <Image
                      src={item?.image}
                      alt={item?.title}
                      className="w-96 h-72 rounded-md object-cover"
                    />
                  </div>
                  <div className="w-full z-10 absolute bg-light-red h-full rounded-md"></div>
                  <div className="absolute z-20 bottom-3 flex flex-col items-center w-full !px-2 space-y-1">
                    <p className='text-white h-16'>{item?.title}</p>
                    <Link to={`/blogs/${item?.id}`} className='flex items-center gap-2 bg-secondary-tw px-2 py-1 !text-white w-fit rounded-md'>
                      <span>
                        {t('custom.more-details')}
                      </span>
                      <span>
                        <ArrowLeft size={18} />
                      </span>
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))
          )}
        </Swiper>

        <button className='relative z-50 flex justify-center items-center size-8 border-2 border-secondary-tw rounded-md text-secondary-tw next-blog'>
          <ChevronLeft size={22} className=" ltr:rotate-180"/>
        </button>
      </section>
     <Link to="/all-blogs" className="flex items-center justify-center mt-4 bg-secondary-tw text-white px-4 py-2 rounded-md hover:bg-secondary-tw/80 transition-colors fs-6 "
     style={{width:'200px',margin:'20px auto'}}
    >
        {t('see-all-blogs')}
      </Link>
    </main>
  );
};

export default Blogs;